import { ApiError } from '../api/client'

/**
 * O cerere care a picat, cu motivul si butonul de reincercare.
 *
 * Garda `if (!query.data) return <Spinner />` se sprijina pe o presupunere:
 * ca datele vin. Cand cererea pica (500, retea), `data` ramane `undefined`
 * pentru totdeauna si spinnerul se invarte fara capat - asa a stat fila
 * Easeedesk din Settings -> Reports. Pagina pune intai 403 (`Forbidden`),
 * apoi eroarea (asta), si abia la urma spinnerul.
 */
export function LoadFailed({ error, onRetry, what = 'This page' }: { error: unknown; onRetry?: () => void; what?: string }) {
  const reason = error instanceof ApiError && error.message ? error.message : error instanceof Error ? error.message : ''

  return (
    <div className="alert alert-danger od-load-failed" role="alert">
      <i className="fas fa-exclamation-circle" aria-hidden="true"></i> {what} could not be loaded.
      {reason ? <> {reason}</> : null}
      {onRetry ? (
        <>
          {' '}
          <button type="button" className="btn btn-sm btn-default od-load-retry" onClick={onRetry}>
            <i className="fas fa-sync-alt" aria-hidden="true"></i> Retry
          </button>
        </>
      ) : null}
    </div>
  )
}
